import { render } from "./RegisterActivity.vue?vue&type=template&id=624e0e53"
import script from "./RegisterActivity.vue?vue&type=script&lang=js"
export * from "./RegisterActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__